<template>
  <section>
    <!-- The accessDialog-overlay -->
    <div id="accessDialog" class="accessDialog-overlay" @click.stop="close()">
      <div class="accessDialog-contentDiv d-flex justify-content-center">
        <div class="accessDialog-content">
          <!-- Button to close the accessDialog-overlay navigation -->
          <div class="accessDialog-centeredContent">
            <span class="accessDialog-logo">
              <span class="accessDialog-heading">
                <h4 v-html="header" />
              </span>
              <span
                class="accessDialog-close-btn"
                @click.stop="close()"
              ><span class="accessDialog-close-btn_x">&times;</span></span>
            </span>
            <span class="accessDialog-text">
              <span v-html="body" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      inVMX: 'instancesState/getInVMX',
    }),
    header() {
      return !this.inVMX && this.$te('PAG.no_access') ? this.$t('PAG.no_access') : this.$t('IndustryLandingPage.no_access')
    },
    body() {
      return !this.inVMX && this.$te('PAG.no_access_text') ? this.$t('PAG.no_access_text') : this.$t('IndustryLandingPage.no_access_text')
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.accessDialog-centeredContent {
  text-align: center;
  padding: 4% 4%;
}

.accessDialog-logo{
  display: flex;
  justify-content: space-between;
}
.accessDialog-close-btn{
  cursor: pointer;
  position: relative;
  top: -15px;

  .accessDialog-close-btn_x{
    font-size: 32px;
  }
}

.accessDialog-heading h4 {
  padding: 10px 0;
  font-weight: bold;
}

.accessDialog-logo img {
  width: 20%;
}

.no-access-text-decoration {
  font-size: 16px;
  color: #000;
  font-weight: 600;
}
.accessDialog-text{
  font-size: 16px;
}
a.accessDialog-butonAccept {
  text-decoration: none;
  padding: 7px 50px;
  background: #0057b8 0 0 no-repeat padding-box;
  color: #fff;
  font-weight: 500;
  border-radius: 2px;
}

.accessDialog-overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  background-color: rgba(0, 13, 38, 0.9);
  overflow-x: hidden;
}
.accessDialog-contentDiv {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.accessDialog-content {
  width: 600px;
  min-height: 222px;
  background-color: white;
  margin: 0 30px;
  border-radius: 10px;
}

.accessDialog-content .text {
  font-size: 16px;
}

@media screen and (max-height: 450px) {
}
</style>
